module.exports = __webpack_public_path__ + "static/media/condutor-logo.8a2d003e.png";